import { render, staticRenderFns } from "./GridNameSubject.vue?vue&type=template&id=7991485a&scoped=true&"
import script from "./GridNameSubject.vue?vue&type=script&lang=js&"
export * from "./GridNameSubject.vue?vue&type=script&lang=js&"
import style0 from "./GridNameSubject.vue?vue&type=style&index=0&id=7991485a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7991485a",
  null
  
)

export default component.exports